import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';

import Container from './Container';
import Home from './Home';
import About from './About';
import Record from './RecordPage.react';
import Browse from './Browse';
import DanceSingle from './DanceSingle';
import DanceLatest from './DanceLatest';
import Thanks from './Thanks';

require('./scss/styles.scss');


ReactDOM.render(
  <Router history={browserHistory}>
    <Route path="/" component={Container}>
      <IndexRoute component={Home} />
      <Route path="about" component={About}/>
      <Route path="record" component={Record}/>
      <Route path="/record/:danceId" component={Record}/>
      <Route path="booth" component={Record}/>
      <Route path="/booth/:danceId" component={Record}/>
      <Route path="watch" component={Browse}/>
      <Route path="watch/completed" component={Browse}/>
      <Route path="/d/:danceId" component={DanceSingle}/>
      <Route path="/latest" component={DanceLatest}/>
      <Route path="thanks" component={Thanks}/>
      <Route path="/thanks/:danceId" component={Thanks}/>
      <Route path="*" component={Home}/>
    </Route>
  </Router>, document.getElementById('container'));



// WEBPACK FOOTER //
// src/app.js